/*-----------------------START GTM VIEW_ITEM_LIST FOR CUSTOM COLLECTIONS--------------------------------*/
let productData = [];
let sortedProductData = [];

function handleViewedProducts(products) {
  let groupProductData = [];

  // Loop through each product and set up intersection observer for visibility tracking
  products.forEach((product, index) => {
    // Get dynamic and static data
    let itemListId = product.querySelector(".gtm-item-list-id").value;
    let itemListName = product.querySelector(".gtm-item-list-name").value;
    let itemAffiliation = product.querySelector(".gtm-affiliation").value;
    let currency = product.querySelector(".gtm-currency").value;
    let itemId = product.querySelector(".gtm-item_id").value;
    let itemName = product.querySelector(".gtm-item_name").value;
    let itemBrand = product.querySelector(".gtm-item_brand").value;
    let itemCategory1 = product.querySelector(".gtm-item_category1")?.value;
    let itemCategory2 = product.querySelector(".gtm-item_category2")?.value;
    let itemCategory3 = product.querySelector(".gtm-item_category3")?.value;
    let itemCategory4 = product.querySelector(".gtm-item_category4")?.value;
    let itemCategory5 = product.querySelector(".gtm-item_category5")?.value;
    let itemVariant = product.querySelector(".gtm-variant")?.value;

    // Get static data
    let indexProduct = index + 1;
    let quantityProduct = 1;

    function parsePrice(priceStr) {
      return parseFloat(priceStr.replace(/,/g, ""));
    }

    //get price & discount
    let fullPrice = 0;
    let discount = 0;
    let pricePrd = parsePrice(product.querySelector(".gtm-price").value);

    let comparePricePrd = parsePrice(
      product.querySelector(".gtm-discount").value,
    );

    if (comparePricePrd > pricePrd) {
      fullPrice = pricePrd;
      discount = parseFloat((comparePricePrd - pricePrd).toFixed(2));
    } else if (pricePrd) {
      fullPrice = pricePrd;
    }

    const productDataObjectList = {
      item_id: itemId,
      item_name: itemName,
      affiliation: itemAffiliation,
      discount: discount,
      index: indexProduct,
      item_brand: itemBrand,
      item_list_id: itemListId,
      item_list_name: itemListName,
      price: fullPrice,
      currency: currency,
      quantity: quantityProduct,
    };

    // If categories exist, add them
    if (itemCategory1) productDataObjectList.item_category = itemCategory1;
    if (itemCategory2) productDataObjectList.item_category2 = itemCategory2;
    if (itemCategory3) productDataObjectList.item_category3 = itemCategory3;
    if (itemCategory4) productDataObjectList.item_category4 = itemCategory4;
    if (itemCategory5) productDataObjectList.item_category5 = itemCategory5;

    // If variant exists, add it
    if (itemVariant && itemVariant !== "Default Title") {
      productDataObjectList.item_variant = itemVariant;
    }

    // Push data into the productData array
    if (!groupProductData.some((prod) => prod.item_id === itemId)) {
      groupProductData.push(productDataObjectList);
      productData.push(productDataObjectList); // Track in the global array
    }
    // Sort the productData and update sortedProductData
  });
  sortedProductData = productData.slice().sort((a, b) => a.index - b.index);
  // Push the event when all products are viewed
  pushEvent();
}

// Function to start observing DOM changes for new products
export function observeForNewProductsCustom() {
  const gtmGroupsCustom = document.querySelectorAll(
    '[data-product-group-gtm-custom="product-group-gtm-custom"]',
  );

  gtmGroupsCustom.forEach((el) => {
    // Run the handler initially for already existing products
    let products = el.querySelectorAll(".each-product-gtm");
    if (products) {
      handleViewedProducts(products);
    }
  });
}

const pushEvent = () => {
  if (sortedProductData.length !== 0) {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      ecommerce: null,
    });

    window.dataLayer.push({
      event: "ec_view_item_list",
      ecommerce: {
        items: sortedProductData,
      },
    });
    productData = [];
    sortedProductData = [];
  }
};

export function handleOnActionPLP() {
  // Clear existing product data
  productData = [];
  sortedProductData = [];

  // Re-observe for new products
  setTimeout(() => {
    observeForNewProductsCustom();
  }, 500);
}
